import { initNav } from "./modules/nav";
import { initNewsletter } from "./modules/newsletter";
import { initFlexVideo } from "./modules/flex-video";
import { initPostGrid } from "./modules/post-grid";
import { initSchedule } from "./modules/schedule";
import { initReviews } from "./modules/reviews";
import { initPartnersCarousel } from "./modules/partners";
import { initEventCarousel } from "./modules/events-carousel";
import { initEventsListPagination } from "./modules/events-list-pagination";
import { initImageGrid } from "./modules/image-grid";
import { initHeroGrid } from "./modules/hero-grid";
import { initModal } from "./modules/modal";
import { initFlexMedia } from "./modules/flex-media";
import { initVenueMap } from "./modules/venue-map";
import { initRoleCards } from "./modules/role-cards";
import { initScrollToTop } from "./modules/scroll-to-top";
import { initHeroMute } from "./modules/hero-mute";
import { initHeroModalVideo } from "./modules/hero-modal-video";

initNav();
initNewsletter();
initFlexVideo();
initPostGrid();
initSchedule();
initReviews();
initPartnersCarousel();
initEventCarousel();
initEventsListPagination();
initImageGrid();
initHeroGrid();
initModal();
initFlexMedia();
initVenueMap();
initRoleCards();
initScrollToTop();
initHeroMute();
initHeroModalVideo();
